/* eslint-disable no-nested-ternary */
import { useEffect, useState } from "react";
import useHttpClient from "shared/hooks/http-hook";
import { Row, Col, Input, Form, Card, Switch, Select, Button, InputNumber, message } from "antd";
import EndPoints from 'shared/endPoints/EndPoints.json';
import { useParams, useHistory } from "react-router-dom";
import Spinner from "components/UIElements/Spiner/Spiner";
import { EditOutlined } from "@ant-design/icons";



export default function DeviceSettings() {
    const [form] = Form.useForm();
    const { record } = useHistory().location.state;
    const [settingsForm] = Form.useForm();
    const { deviceImei } = useParams();
    const { responseData, sendRequest, loading, requestIdentifier } = useHttpClient();
    const [disabled, setDisabled] = useState(true);
     const history = useHistory();
    const PCL = 3;

    const mode = [
        { label: 'Passenger Mode', value: 'passenger mode' },
        { label: 'Tracker Mode', value: 'tracker mode' },
    ]

    const formItemLayout = {
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 9
        },
    };


    useEffect(() => {
        if (responseData && requestIdentifier === 'GETSETTINGS') {
            form.setFieldsValue({
                dateCreated: record?.dateCreated,
                deviceImei: record?.deviceImei,
                simImsi: record?.simImsi,
                parcelId: record?.parcelId,
                status: record?.status,
                macAddress: record?.macAddress
            })
            settingsForm.setFieldsValue({
                systemSound: responseData?.systemSound,
                timeInterval: responseData?.timeInterval,
                mode: responseData?.mode
            })
        }

    }, [responseData, form, settingsForm, requestIdentifier])

        useEffect(() => {
        if (responseData && requestIdentifier === 'RESETBEACON') {
            message.success('Η συσκευή μηδενίστηκε επιτυχώς');
            history.push('/choices/configDevice?PackingStatusId=3');
        }
    }, [responseData, requestIdentifier])

    useEffect(() => {
        sendRequest({
            endpoint: `${EndPoints.DEVICE.GETSETTINGS}?DeviceImei=${deviceImei}`,
            method: 'GET',
        }, 'GETSETTINGS')
    }, [sendRequest, deviceImei, settingsForm, form, requestIdentifier])


    const onFinish = (fieldsValues) => {
        const data = { ...fieldsValues, id: responseData.id, modeTypeId: fieldsValues.mode === 'passenger mode' ? 1 : 2 }
        setDisabled(true)
        sendRequest({
            endpoint: EndPoints.DEVICE.CHANGESETTINGS,
            method: 'PUT',
            data
        }, 'PUTSETTINGS')
    }
    const resetDevice = () => {
            sendRequest({
            endpoint: `${EndPoints.PACKING.RESETBEACON}/${record.id}`,
            method: 'PUT',
            
        }, 'RESETBEACON')          
    }
    return (
        <>
            <Card type="inner" headStyle={{ margin: '5px', textAlign: 'center' }} title="Λεπτομέρειες Συσκευής">
                <Form
                    {...formItemLayout}
                    form={form}
                >
                    <Row>
                        <Col span={24} pull={5} >
                            <Form.Item
                                label="Ημερομηνία Εισαγωγής"
                                name="dateCreated"
                            >
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Imei Συσκευής"
                                name="deviceImei"
                            >
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        {record?.deviceTypeId <PCL ? 
                        <Col span={12} >
                            <Form.Item
                                label="IMSI Sim Κάρτας"
                                name="simImsi"
                            >
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        :
                        <Col span={12} >
                            <Form.Item
                                label="MAC Address"
                                name="macAddress"
                            >
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                    }
                        <Col span={12} >
                            <Form.Item
                                label="Αριθμός Κιβωτίου"
                                name="parcelId"
                            >
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                                label="Κατάσταση Πακέτου"
                                name="status"
                            >
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                      {record.status ==="Προς Μηδενισμό" && 
                        <Col  span={12} push={17}>
                            <Button style={{ backgroundColor: 'red' }}  onClick={resetDevice} >
                                Μηδενισμός Συσκευής
                            </Button>    
                        </Col>}
                    </Row>
                </Form>
            </Card>
            {record?.deviceTypeId < PCL && 
                (!loading ?  
                (<Card type="inner" headStyle={{ margin: '5px', justifyContent: 'center', textAlign: 'center' }} title="Ρυθμίσεις Συσκευής">
                    <Form
                        {...formItemLayout}
                        form={settingsForm}
                        onFinish={onFinish}
                    >
                        <Row>
                            <Col style={{ fontSize: "20px" }} span={18} push={6}>
                                <EditOutlined onClick={() => setDisabled(!disabled)} />
                            </Col>
                            <Col span={24} >
                                <Form.Item label="Ήχος Συστήματος" name="systemSound" valuePropName="checked" >
                                    <Switch defaultChecked disabled={disabled} />
                                </Form.Item>
                            </Col>
                            <Col span={24} >
                                <Form.Item
                                    extra="seconds (range 10-1440)"
                                    label="Sleep Timer Upload Interval acquation time interval"
                                    name="timeInterval" >
                                    <InputNumber disabled={disabled} min={10} max={1440} />
                                </Form.Item>
                            </Col>
                            <Col span={24} >
                                <Form.Item label="mode" name="mode" >
                                    <Select disabled={disabled} >
                                        {mode.map((m) => <Select.Option key={m.value} value={m.value}>{m.label}</Select.Option>)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8} push={16} >
                                <Form.Item >
                                    <Button disabled={disabled} htmlType="submit" >Αποθήκευση</Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>) 
                : <Spinner /> )
            }       
        </>
    )
}